import 'classlist-polyfill';
import 'events-polyfill';
import 'core-js/es/number/parse-int'; // eslint-disable-line import/no-extraneous-dependencies
import 'core-js/es/string/pad-start'; // eslint-disable-line import/no-extraneous-dependencies

import responsiveVideos from './components/layout/responsiveVideos';
import header from './components/layout/header';
import languageSelectors from './components/layout/language-selector';
import sliders from './components/sliders/sliders';
import quantitySelect from './components/layout/quantitySelect';
import validation from './components/forms/validation';
// import RecaptchaForm from './components/forms/RecaptchaForm';
// import cookieNotification from './components/cookies/cookieNotification';
import ModalManager from './components/modals/ModalManager';
import PredictiveSearch from './components/search/PredictiveSearch';
import CartModal from './components/cart/CartModal';
import invoice from './components/cart/invoice';
import Index from './pages/Index';
import Cart from './pages/Cart';
import Contact from './pages/Contact';
import Components from './pages/Components';
import CustomersAddresses from './pages/CustomersAddresses';
import Product from './pages/Product';
import CustomersLogin from './pages/CustomersLogin';
import jobsNavigation from './components/layout/jobsNavigation';
import formBuilder from './components/forms/formBuilder';

import accordion from './components/layout/accordion';
import scrollTo from './components/layout/scrollTo';
import modalEvents from './components/modals/modalEvents';
import productItem from './components/cart/productItem';
// import promoModal from './components/modals/promoModal';
import timeline from './components/timeline/timeline';
import announcementModal from './components/modals/announcementModal';
import tabs from './components/tabs/tabs';
import geolocation from './components/geolocation/geolocation';

require('./utils/nativeConsole');
// require('jquery-touchswipe/jquery.touchSwipe'); // use with fancybox, cycle2, etc
// import objectFitImages from 'object-fit-images';
// Set js class
const htmlClassList = document.documentElement.classList;
htmlClassList.add('js');
htmlClassList.remove('no-js');

window.modalManager = new ModalManager();

// Layout setup
responsiveVideos();
// cookieNotification();
quantitySelect();
accordion();
header();
languageSelectors();
sliders();
scrollTo();
productItem();
timeline();
announcementModal();
invoice();
jobsNavigation();
formBuilder();
tabs();
geolocation();

// Forms
validation();

// if (document.getElementById('form-newsletter')) {
//   const newsletterForm = new RecaptchaForm('#form-newsletter');
//   window.submitRecaptchaFormNewsletter = () => {
//     newsletterForm.submitCallback();
//   };
// }

// Cart
window.cartModal = new CartModal();
modalEvents();

// Promo modal
// promoModal();

// Search
const searchBars = document.querySelectorAll('.search-bar');
searchBars.forEach(el => {
  if (el.classList.contains('js-predictive-search-blog')) {
    // eslint-disable-next-line no-new
    new PredictiveSearch(el, true);
  } else {
    // eslint-disable-next-line no-new
    new PredictiveSearch(el);
  }
});

// Enable this if you want to test ga calls in development
// gaDevelopment();

// Page specific classes
const pages = {
  Index,
  Cart,
  Contact,
  Components,
  CustomersAddresses,
  Product,
  CustomersLogin,
};

// Get page class from template datapage
const currentPage = `-${document.documentElement.getAttribute('data-page')}`;
if (currentPage) {
  const pageClassName = currentPage.split('-').reduce((accumulator, currentValue) => {
    return accumulator + currentValue.charAt(0).toUpperCase() + currentValue.slice(1);
  });

  if (pageClassName !== '' && typeof pages[pageClassName] === 'function') {
    new pages[pageClassName](); // eslint-disable-line no-new
  }
}

window.modalManager.checkModalOnPageLoad();
